import{
    scpIssuerConstants,
    nameSpace
} from  "../constants/scpIssuerConfig.constants";

const initialState={
    loading: false,
    success: false,
    request: null,
    response: null,
    error: null 
};

export const getAllScpIssuerConfig= (state = initialState, action) => {
    switch (action.type) {
      case  scpIssuerConstants[`GET_${nameSpace}_REQUEST`]:
        return {
          ...state,
          loading: true,
          response: null,
          request: action.request
        };
      case  scpIssuerConstants[`GET_${nameSpace}_SUCCESS`]:
        return {
          ...state,
          loading: false,
          success: true,
          response: action.response,
          error: null
        };
      case  scpIssuerConstants[`GET_${nameSpace}_FAILURE`]:
        return {
          ...state,
          loading: false,
          success: false,
          response: null,
          error: action.error
        };
      case  scpIssuerConstants[`GET_${nameSpace}_RESET`]:
        return {
          ...state,
          ...initialState
        };
      default:
        return state;
    }
  };